<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

  <mat-tab-group class="mt-2">
    <mat-tab>
      <ng-template mat-tab-label class="width-set">
        <span>Part 8</span>
      </ng-template>
      <ng-template matTabContent>
        <form
          #df="ngForm"
          novalidate
          (keydown.enter)="onSearchDNBReport()"
          class="formborder"
        >
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-3">
              <span class="required-lable"> From Date </span>
              <div class="datepicker_feild">
                <input
                  [matDatepicker]="picker1"
                  dateConvert
                  placeholder="DD/MM/YYYY"
                  name="FromDate"
                  id="FromDate"
                  required
                  #refFromDate="ngModel"
                  class="form-control input-text-css"
                  [(ngModel)]="FromDate"
                  [ngClass]="{
                    'is-invalid': df.submitted && refFromDate.invalid,
                    'alert-warning':
                      refFromDate.invalid &&
                      (refFromDate.dirty ||
                        refFromDate.touched ||
                        refFromDate.untouched)
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <span class="required-lable"> To Date </span>
              <div class="datepicker_feild">
                <input
                  [matDatepicker]="picker"
                  dateConvert
                  placeholder="DD/MM/YYYY"
                  name="ToDate"
                  id="ToDate"
                  required
                  #refToDate="ngModel"
                  class="form-control input-text-css"
                  [(ngModel)]="ToDate"
                  [ngClass]="{
                    'is-invalid': df.submitted && refToDate.invalid,
                    'alert-warning':
                      refToDate.invalid &&
                      (refToDate.dirty ||
                        refToDate.touched ||
                        refToDate.untouched)
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <span class="required-lable">Slab Name</span>
              <select
                name="SlabId"
                id="SlabId"
                [(ngModel)]="SlabId"
                class="form-control input-text-css"
                required
                #refSlabId="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refSlabId.invalid,
                  'alert-warning':
                    refSlabId.invalid &&
                    (refSlabId.dirty ||
                      refSlabId.touched ||
                      refSlabId.untouched)
                }"
              >
                <option value="">Select Slab Name</option>
                <option *ngFor="let row of SlabData" [value]="row.Id">
                  {{ row.Slab_name }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <button
                type="button"
                (click)="onSearchDNBReport()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!df.form.valid"
              >
                Search
              </button>
            </div>
            <div class="col-md-4 mt-2" [hidden]="!DataSource">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input
                      type="text"
                      id="FilterInputSearch"
                      (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch"
                      placeholder="What're you searching for?"
                      class="form-control border-0 bg-light"
                    />
                    <div class="input-group-append">
                      <button
                        id="button-addon1"
                        type="submit"
                        class="btn btn-link text-primary"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </form>

        <div class="mt-3" *ngIf="DataSource?.data?.length > 0">
          <div class="table-responsive" style="max-width: 100%">
            <mat-table
              [dataSource]="DataSource"
              matSort
              #summarySort="matSort"
              matTableExporter
              #exporter1="matTableExporter"
              class="mat-elevation-z8"
            >
              <ng-container matColumnDef="Id">
                <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index">{{
                  i + 1
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Product_Name">
                <mat-header-cell *matHeaderCellDef
                  >Product Name</mat-header-cell
                >
                <mat-cell
                  *matCellDef="let row"
                  class="text-primary"
                  (click)="onclickDetail(row)"
                >
                  {{ row.Product_Name }}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_Exposer_PrincipalCount">
                <mat-header-cell *matHeaderCellDef
                  >Opening Exposure Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_Exposer_PrincipalCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_Exposer_PrincipalCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_Exposer_Principal">
                <mat-header-cell *matHeaderCellDef
                  >Opening Exposure Principal</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_Exposer_Principal
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_Exposer_Principal")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_STDCount">
                <mat-header-cell *matHeaderCellDef
                  >Opening STD Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_STDCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_STDCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_STD">
                <mat-header-cell *matHeaderCellDef>Opening STD</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_STD
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_STD")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_NPACount">
                <mat-header-cell *matHeaderCellDef
                  >Opening NPA Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_NPACount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_NPACount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Before_NPA">
                <mat-header-cell *matHeaderCellDef>Opening NPA</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Before_NPA
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Before_NPA")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="addtionCount">
                <mat-header-cell *matHeaderCellDef
                  >Addition Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.addtionCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("addtionCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="addtion">
                <mat-header-cell *matHeaderCellDef>Addition</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.addtion
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("addtion")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Up_gradationCount">
                <mat-header-cell *matHeaderCellDef
                  >Upgradation Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Up_gradationCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Up_gradationCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Up_gradation">
                <mat-header-cell *matHeaderCellDef>Upgradation</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Up_gradation
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Up_gradation")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="RecoveryCount">
                <mat-header-cell *matHeaderCellDef
                  >Recovery Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.RecoveryCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("RecoveryCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="Recovery">
                <mat-header-cell *matHeaderCellDef>Recovery</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.Recovery
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("Recovery")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="WrittenOffCount">
                <mat-header-cell *matHeaderCellDef
                  >Written Off Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.WrittenOffCount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("WrittenOffCount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="WrittenOff">
                <mat-header-cell *matHeaderCellDef>Written Off</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.WrittenOff
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("WrittenOff")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="After_NPACount">
                <mat-header-cell *matHeaderCellDef
                  >Closing NPA Count</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.After_NPACount
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("After_NPACount")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="After_NPAsum">
                <mat-header-cell *matHeaderCellDef
                  >Closing NPA Sum</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.After_NPAsum
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("After_NPAsum")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="After_STD">
                <mat-header-cell *matHeaderCellDef>Closing STD</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.After_STD
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("After_STD")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="SubStandard">
                <mat-header-cell *matHeaderCellDef
                  >Sub Standard</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.SubStandard
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("SubStandard")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="DoubtfulAssets">
                <mat-header-cell *matHeaderCellDef
                  >Doubtful Assets</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.DoubtfulAssets
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("DoubtfulAssets")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="LossAssets">
                <mat-header-cell *matHeaderCellDef>Loss Assets</mat-header-cell>
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.LossAssets
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("LossAssets")
                }}</mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="After_Exposer_Principal">
                <mat-header-cell *matHeaderCellDef
                  >Closing Exposure Principal</mat-header-cell
                >
                <mat-cell *matCellDef="let row" class="text-right">{{
                  row.After_Exposer_Principal
                }}</mat-cell>
                <mat-footer-cell *matFooterCellDef class="text-right">{{
                  getTotalSummary("After_Exposer_Principal")
                }}</mat-footer-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>
              <mat-footer-row
                *matFooterRowDef="displayedColumns"
              ></mat-footer-row>
            </mat-table>
            <div class="row m-0 align-items-center justify-content-between">
              <div class="col-md-4">
                <button
                  class="mt-3 btn font-size-12 button-btn"
                  (click)="exportTable1(exporter1)"
                >
                  <i
                    class="fa fa-file-export mr-1"
                    style="font-size: medium; cursor: pointer"
                  ></i>
                  Export
                </button>
              </div>

              <mat-paginator
                #summaryPaginator
                [pageSizeOptions]="[20, 50]"
                showFirstLastButtons
              ></mat-paginator>
            </div>
          </div>
        </div>
        <div
          *ngIf="DataSource && DataSource.data?.length === 0"
          class="text-center mt-3"
        >
          <p class="text-muted">No data available for the selected criteria.</p>
        </div>
        <div
          class="modal fade in"
          id="DNB2DetailModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          data-backdrop="false"
          style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
        >
          <div
            class="modal-dialog modal-xl modal-dialog-centered"
            role="document"
          >
            <div
              cdkDrag
              cdkDragRootElement=".cdk-overlay-pane"
              class="modal-content"
            >
              <div cdkDragHandle class="modal-header" style="padding: 10px">
                <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
                  {{ modalTitle }}
                </h6>
                <button
                  type="button"
                  (click)="closeModal()"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <i class="far text-black fa-times-circle"></i>
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="col-md-4 mt-2" [hidden]="!DataSourceDetail">
                  <form action="" class="search-text">
                    <div class="bg-light rounded rounded-pill shadow-sm">
                      <div class="input-group">
                        <input
                          type="text"
                          id="FilterInputSearch"
                          (keyup)="applyFilter($event.target.value)"
                          name="FilterInputSearch"
                          placeholder="What're you searching for?"
                          class="form-control border-0 bg-light"
                        />
                        <div class="input-group-append">
                          <button
                            id="button-addon1"
                            type="submit"
                            class="btn btn-link text-primary"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  class="table-responsive"
                  *ngIf="DataSourceDetail?.data?.length > 0 && !showSpinner"
                >
                  <mat-table
                    [dataSource]="DataSourceDetail"
                    matSort
                    #detailSort="matSort"
                    matTableExporter
                    #exporter="matTableExporter"
                  >
                    <ng-container matColumnDef="Id">
                      <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                      <mat-cell *matCellDef="let row; let i = index">{{
                        i + 1
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="LoanAcNo">
                      <mat-header-cell *matHeaderCellDef
                        >Loan A/C No</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">{{
                        row.LoanAcNo
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Product_Name">
                      <mat-header-cell *matHeaderCellDef
                        >Product</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">{{
                        row.Product_Name
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Branch_Name">
                      <mat-header-cell *matHeaderCellDef
                        >Branch</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">{{
                        row.Branch_Name
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="CustomerName">
                      <mat-header-cell *matHeaderCellDef
                        >Customer</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">{{
                        row.CustomerName
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Loan_Date">
                      <mat-header-cell *matHeaderCellDef
                        >Loan Date</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">{{
                        row.Loan_Date | date : "dd-MMM-yyyy"
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="LoanClosed_Date">
                      <mat-header-cell *matHeaderCellDef
                        >Loan Closed Date</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">
                        {{
                          row.LoanClosed_Date
                            ? (row.LoanClosed_Date | date : "dd-MMM-yyyy")
                            : "-"
                        }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Application_LoanAmount">
                      <mat-header-cell *matHeaderCellDef
                        >Loan Amount</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Application_LoanAmount
                      }}</mat-cell>
                      <mat-footer-cell
                        *matFooterCellDef
                        class="text-right"
                      ></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_Exposer_PrincipalCount">
                      <mat-header-cell *matHeaderCellDef
                        >Opening Exposure Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_Exposer_PrincipalCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_Exposer_PrincipalCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_Exposer_Principal">
                      <mat-header-cell *matHeaderCellDef
                        >Opening Exposure Principal</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_Exposer_Principal
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_Exposer_Principal")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_STDCount">
                      <mat-header-cell *matHeaderCellDef
                        >Opening STD Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_STDCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_STDCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_STD">
                      <mat-header-cell *matHeaderCellDef
                        >Opening STD</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_STD
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_STD")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_NPACount">
                      <mat-header-cell *matHeaderCellDef
                        >Opening NPA Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_NPACount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_NPACount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Before_NPA">
                      <mat-header-cell *matHeaderCellDef
                        >Opening NPA</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Before_NPA
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Before_NPA")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="addtionCount">
                      <mat-header-cell *matHeaderCellDef
                        >Addition Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.addtionCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("addtionCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="addtion">
                      <mat-header-cell *matHeaderCellDef
                        >Addition</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.addtion
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("addtion")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Up_gradationCount">
                      <mat-header-cell *matHeaderCellDef
                        >Upgradation Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Up_gradationCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Up_gradationCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Up_gradation">
                      <mat-header-cell *matHeaderCellDef
                        >Upgradation</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Up_gradation
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Up_gradation")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="RecoveryCount">
                      <mat-header-cell *matHeaderCellDef
                        >Recovery Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.RecoveryCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("RecoveryCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="Recovery">
                      <mat-header-cell *matHeaderCellDef
                        >Recovery</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.Recovery
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("Recovery")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="WrittenOffCount">
                      <mat-header-cell *matHeaderCellDef
                        >Written Off Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.WrittenOffCount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("WrittenOffCount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="WrittenOff">
                      <mat-header-cell *matHeaderCellDef
                        >Written Off</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.WrittenOff
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("WrittenOff")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="After_NPACount">
                      <mat-header-cell *matHeaderCellDef
                        >Closing NPA Count</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.After_NPACount
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("After_NPACount")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="After_NPA">
                      <mat-header-cell *matHeaderCellDef
                        >Closing NPA</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.After_NPA
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("After_NPA")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="After_STD">
                      <mat-header-cell *matHeaderCellDef
                        >Closing STD</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.After_STD
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("After_STD")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="SubStandard">
                      <mat-header-cell *matHeaderCellDef
                        >SubStandard</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.SubStandard
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("SubStandard")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="DoubtfulAssets">
                      <mat-header-cell *matHeaderCellDef
                        >Doubtful Assets</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.DoubtfulAssets
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("DoubtfulAssets")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="LossAssets">
                      <mat-header-cell *matHeaderCellDef
                        >Loss Assets</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.LossAssets
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("LossAssets")
                      }}</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="After_Exposer_Principal">
                      <mat-header-cell *matHeaderCellDef
                        >Closing Exposure Principal</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row" class="text-right">{{
                        row.After_Exposer_Principal
                      }}</mat-cell>
                      <mat-footer-cell *matFooterCellDef class="text-right">{{
                        getTotal("After_Exposer_Principal")
                      }}</mat-footer-cell>
                    </ng-container>

                    <mat-header-row
                      *matHeaderRowDef="displayedColumnsDetail; sticky: true"
                    ></mat-header-row>
                    <mat-row
                      *matRowDef="let row; columns: displayedColumnsDetail"
                    ></mat-row>
                    <mat-footer-row
                      *matFooterRowDef="displayedColumnsDetail"
                    ></mat-footer-row>
                  </mat-table>

                  <div class="col-md-4">
                    <button
                      class="mt-3 btn font-size-12 button-btn"
                      (click)="exportTable(exporter)"
                    >
                      <i
                        class="fa fa-file-export mr-1"
                        style="font-size: medium; cursor: pointer"
                      ></i>
                      Export
                    </button>
                  </div>

                  <mat-paginator
                    #detailPaginator
                    [pageSizeOptions]="[20, 50]"
                    showFirstLastButtons
                  ></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <!-- top 50 -->
    <mat-tab>
      <ng-template mat-tab-label class="width-set">
        <span>Top 50 Customers</span>
      </ng-template>
      <ng-template matTabContent>
        <form
          #df="ngForm"
          novalidate
          (keydown.enter)="onSearchTop50()"
          class="formborder"
        >
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-3">
              <span class="required-lable"> To Date </span>
              <div class="datepicker_feild">
                <input
                  [matDatepicker]="pickertop50"
                  dateConvert
                  placeholder="DD/MM/YYYY"
                  name="ToDate"
                  id="ToDate"
                  required
                  #refToDate="ngModel"
                  class="form-control input-text-css"
                  [(ngModel)]="ToDatetop50"
                  [ngClass]="{
                    'is-invalid': df.submitted && refToDate.invalid,
                    'alert-warning':
                      refToDate.invalid &&
                      (refToDate.dirty ||
                        refToDate.touched ||
                        refToDate.untouched)
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickertop50"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickertop50></mat-datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <span class="required-lable">Slab Name</span>
              <select
                name="SlabId"
                id="SlabId"
                [(ngModel)]="SlabIdtop50"
                class="form-control input-text-css"
                required
                #refSlabId="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refSlabId.invalid,
                  'alert-warning':
                    refSlabId.invalid &&
                    (refSlabId.dirty ||
                      refSlabId.touched ||
                      refSlabId.untouched)
                }"
              >
                <option value="">Select Slab Name</option>
                <option *ngFor="let row of SlabData" [value]="row.Id">
                  {{ row.Slab_name }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <button
                type="button"
                (click)="onSearchTop50()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!df.form.valid"
              >
                Search
              </button>
            </div>
            <div class="col-md-4 mt-2" [hidden]="!DataSourcetop50">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input
                      type="text"
                      id="FilterInputSearch"
                      (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch"
                      placeholder="What're you searching for?"
                      class="form-control border-0 bg-light"
                    />
                    <div class="input-group-append">
                      <button
                        id="button-addon1"
                        type="submit"
                        class="btn btn-link text-primary"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </form>

        <div
          class="table-responsive mt-3"
          *ngIf="DataSourcetop50?.data?.length > 0"
        >
          <table
            mat-table
            [dataSource]="DataSourcetop50"
            matSort
            #top50Sort="matSort"
            matTableExporter
            #exporterTop50="matTableExporter"
            class="mat-elevation-z8"
          >
            <ng-container matColumnDef="CustomerId">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Sr No.
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index">
                {{ i + 1 }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="NameOfBorrower">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Name Of Borrower
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                class="text-primary"
                (click)="onclickDetailTop50(row)"
              >
                {{ row.NameOfBorrower }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Pan_Number">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                PAN Number
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.Pan_Number }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="CustomerType">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Customer Type
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.CustomerType }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TotalSanctionedLoanAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Total Sanctioned Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TotalSanctionedLoanAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("TotalSanctionedLoanAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="DisbursedLoanAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Disbursed Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.DisbursedLoanAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("DisbursedLoanAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="UndisbursedLoanAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Undisbursed Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.UndisbursedLoanAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("UndisbursedLoanAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TotalPrincipalOutstandingAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Principal Outstanding
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TotalPrincipalOutstandingAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("TotalPrincipalOutstandingAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TotalAccruedInterestAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Accrued Interest
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TotalAccruedInterestAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("TotalAccruedInterestAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="AmountOutstanding">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Amount Outstanding
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.AmountOutstanding }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalTop50("AmountOutstanding") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="StatusofAccount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Status
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.StatusofAccount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumnstop50"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumnstop50"
            ></mat-row>
            <mat-footer-row
              *matFooterRowDef="displayedColumnstop50"
            ></mat-footer-row>
          </table>
          <div class="row m-0 align-items-center justify-content-between">
            <div class="col-md-4">
              <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportTableTop50(exporterTop50)"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>

            <mat-paginator
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
              #top50Paginator
            ></mat-paginator>
          </div>
        </div>
        <!-- Top 50 model -->
        <div
          class="modal fade in"
          id="Top50DetailModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          data-backdrop="false"
          style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
        >
          <div
            class="modal-dialog modal-xl modal-dialog-centered"
            role="document"
          >
            <div
              cdkDrag
              cdkDragRootElement=".cdk-overlay-pane"
              class="modal-content"
            >
              <div cdkDragHandle class="modal-header" style="padding: 10px">
                <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
                  {{ modalTitle }}
                </h6>
                <button
                  type="button"
                  (click)="closeModal()"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <i class="far text-black fa-times-circle"></i>
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="col-md-4 mt-2 p-0" [hidden]="!DataSourcetop50">
                  <form action="" class="search-text">
                    <div class="bg-light rounded rounded-pill shadow-sm">
                      <div class="input-group">
                        <input
                          type="text"
                          id="FilterInputSearch"
                          (keyup)="applyFilter($event.target.value)"
                          name="FilterInputSearch"
                          placeholder="What're you searching for?"
                          class="form-control border-0 bg-light"
                        />
                        <div class="input-group-append">
                          <button
                            id="button-addon1"
                            type="submit"
                            class="btn btn-link text-primary"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  class="table-responsive mt-3"
                  *ngIf="DataSourcetop50?.data?.length > 0"
                >
                  <table
                    mat-table
                    [dataSource]="DataSourcetop50Model"
                    matSort
                    #detailSortTop50="matSort"
                    matTableExporter
                    #exporterTop50Model="matTableExporter"
                    class="mat-elevation-z8"
                  >
                    <ng-container matColumnDef="CustomerId">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Sr No.
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row; let i = index">
                        {{ i + 1 }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="NameOfBorrower">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Name Of Borrower
                      </mat-header-cell>
                      <mat-cell
                        *matCellDef="let row"
                        class="text-primary"
                        (click)="onclickDetailTop50(row)"
                      >
                        {{ row.NameOfBorrower }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="Pan_Number">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        PAN Number
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.Pan_Number }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="CustomerType">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Customer Type
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.CustomerType }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="TotalSanctionedLoanAmount">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Total Sanctioned Loan
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.TotalSanctionedLoanAmount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{ getTotalDetailTop50("TotalSanctionedLoanAmount") }}
                      </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="DisbursedLoanAmount">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Disbursed Loan
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.DisbursedLoanAmount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{ getTotalDetailTop50("DisbursedLoanAmount") }}
                      </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="UndisbursedLoanAmount">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Undisbursed Loan
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.UndisbursedLoanAmount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{ getTotalDetailTop50("UndisbursedLoanAmount") }}
                      </mat-footer-cell>
                    </ng-container>

                    <ng-container
                      matColumnDef="TotalPrincipalOutstandingAmount"
                    >
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Principal Outstanding
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.TotalPrincipalOutstandingAmount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{
                          getTotalDetailTop50("TotalPrincipalOutstandingAmount")
                        }}
                      </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="TotalAccruedInterestAmount">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Accrued Interest
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.TotalAccruedInterestAmount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{ getTotalDetailTop50("TotalAccruedInterestAmount") }}
                      </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="StatusofAccount">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Status
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.StatusofAccount }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="AmountOutstanding">
                      <mat-header-cell *matHeaderCellDef mat-sort-header>
                        Amount Outstanding
                      </mat-header-cell>
                      <mat-cell *matCellDef="let row">
                        {{ row.AmountOutstanding }}
                      </mat-cell>
                      <mat-footer-cell *matFooterCellDef>
                        {{ getTotalDetailTop50("AmountOutstanding") }}
                      </mat-footer-cell>
                    </ng-container>

                    <mat-header-row
                      *matHeaderRowDef="displayedColumnstop50"
                    ></mat-header-row>
                    <mat-row
                      *matRowDef="let row; columns: displayedColumnstop50"
                    ></mat-row>
                    <mat-footer-row
                      *matFooterRowDef="displayedColumnstop50"
                    ></mat-footer-row>
                  </table>

                  <div
                    class="row m-0 align-items-center justify-content-between"
                  >
                    <div class="col-md-4">
                      <button
                        class="mt-3 btn font-size-12 button-btn"
                        (click)="exportTableTop50Model(exportTableTop50Model)"
                      >
                        <i class="fa fa-file-export mr-1"></i>
                        Export
                      </button>
                    </div>

                    <div class="col-md-8">
                      <mat-paginator
                        [pageSizeOptions]="[20, 50]"
                        showFirstLastButtons
                        #detailPaginatorTop50
                      ></mat-paginator>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>

    <!-- NPA Report -->
    <mat-tab>
      <ng-template mat-tab-label class="width-set">
        <span>NPA Report</span>
      </ng-template>
      <ng-template matTabContent>
        <form
          #df="ngForm"
          novalidate
          (keydown.enter)="onSearchNpaReport()"
          class="formborder"
        >
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-3">
              <span class="required-lable"> To Date </span>
              <div class="datepicker_feild">
                <input
                  [matDatepicker]="pickertop50"
                  dateConvert
                  placeholder="DD/MM/YYYY"
                  name="ToDate"
                  id="ToDate"
                  required
                  #refToDate="ngModel"
                  class="form-control input-text-css"
                  [(ngModel)]="ToDateNPA"
                  [ngClass]="{
                    'is-invalid': df.submitted && refToDate.invalid,
                    'alert-warning':
                      refToDate.invalid &&
                      (refToDate.dirty ||
                        refToDate.touched ||
                        refToDate.untouched)
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickertop50"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickertop50></mat-datepicker>
              </div>
            </div>
            <div class="col-md-3">
              <span class="required-lable">Slab Name</span>
              <select
                name="SlabId"
                id="SlabId"
                [(ngModel)]="SlabIdNPA"
                class="form-control input-text-css"
                required
                #refSlabId="ngModel"
                [ngClass]="{
                  'is-invalid': df.submitted && refSlabId.invalid,
                  'alert-warning':
                    refSlabId.invalid &&
                    (refSlabId.dirty ||
                      refSlabId.touched ||
                      refSlabId.untouched)
                }"
              >
                <option value="">Select Slab Name</option>
                <option *ngFor="let row of SlabData" [value]="row.Id">
                  {{ row.Slab_name }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <button
                type="button"
                (click)="onSearchNpaReport()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!df.form.valid"
              >
                Search
              </button>
            </div>
            <div class="col-md-4 mt-2" [hidden]="!DataSourceNPA">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input
                      type="text"
                      id="FilterInputSearch"
                      (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch"
                      placeholder="What're you searching for?"
                      class="form-control border-0 bg-light"
                    />
                    <div class="input-group-append">
                      <button
                        id="button-addon1"
                        type="submit"
                        class="btn btn-link text-primary"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </form>
        <div
          class="table-responsive mt-3"
          *ngIf="DataSourceNPA?.data?.length > 0"
        >
          <table
            mat-table
            [dataSource]="DataSourceNPA"
            matSort
            #NpaSort="matSort"
            matTableExporter
            #exporterNPA="matTableExporter"
            class="mat-elevation-z8"
          >
            <ng-container matColumnDef="CustomerId">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Sr No.
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index">
                {{ i + 1 }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="NameOfBorrower">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Name Of Borrower
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.NameOfBorrower }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Pan_Number">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                PAN Number
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.Pan_Number }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="CustomerType">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Customer Type
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.CustomerType }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="CIN_No">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                CIN No
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.CIN_No }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="LoanPurpose">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Loan Purpose
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.LoanPurpose }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="LoanDuration_Month">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Loan Duration (Months)
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.LoanDuration_Month }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="Product_Name">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Product Name
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.Product_Name }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TypeaOfLoan">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Type Of Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TypeaOfLoan }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TotalSanctionedLoanAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Total Sanctioned Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TotalSanctionedLoanAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalNPA("TotalSanctionedLoanAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="TotalOutstandingLoanAmount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Total Outstanding Loan
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.TotalOutstandingLoanAmount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalNPA("TotalOutstandingLoanAmount") }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="DateofLastPayment">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Date of Last Payment
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.DateofLastPayment }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="DateofFirstDefault">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Date of First Default
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.DateofFirstDefault }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="StatusofAccount">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                Status of Account
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.StatusofAccount }}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumnsNPA"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumnsNPA"
            ></mat-row>
            <mat-footer-row
              *matFooterRowDef="displayedColumnsNPA"
            ></mat-footer-row>
          </table>

          <div class="row m-0 align-items-center justify-content-between">
            <div class="col-md-4">
              <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportTableNPA(exporterNPA)"
              >
                <i class="fa fa-file-export mr-1"></i>
                Export
              </button>
            </div>

            <div class="col-md-8">
              <mat-paginator
                [pageSizeOptions]="[20, 50]"
                showFirstLastButtons
                #NpaPaginator
              ></mat-paginator>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <!-- Branch Report -->
    <mat-tab>
      <ng-template mat-tab-label class="width-set">
        <span>Branch Report</span>
      </ng-template>
      <ng-template matTabContent>
        <form
          #df="ngForm"
          novalidate
          (keydown.enter)="onSearchBranchReport()"
          class="formborder"
        >
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-3">
              <span class="required-lable"> To Date </span>
              <div class="datepicker_feild">
                <input
                  [matDatepicker]="pickertop50"
                  dateConvert
                  placeholder="DD/MM/YYYY"
                  name="ToDate"
                  id="ToDate"
                  required
                  #refToDate="ngModel"
                  class="form-control input-text-css"
                  [(ngModel)]="ToDateBranch"
                  [ngClass]="{
                    'is-invalid': df.submitted && refToDate.invalid,
                    'alert-warning':
                      refToDate.invalid &&
                      (refToDate.dirty ||
                        refToDate.touched ||
                        refToDate.untouched)
                  }"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickertop50"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickertop50></mat-datepicker>
              </div>
            </div>
            <div class="col-md-4">
              <button
                type="button"
                (click)="onSearchBranchReport()"
                class="mt-3 btn font-size-12 button-btn"
                [disabled]="!df.form.valid"
              >
                Search
              </button>
            </div>
            <div class="col-md-4 mt-2" [hidden]="!DataSourceBranch">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input
                      type="text"
                      id="FilterInputSearch"
                      (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch"
                      placeholder="What're you searching for?"
                      class="form-control border-0 bg-light"
                    />
                    <div class="input-group-append">
                      <button
                        id="button-addon1"
                        type="submit"
                        class="btn btn-link text-primary"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </form>
        <!-- branch table -->

        <div
          class="table-responsive mt-3"
          *ngIf="DataSourceBranch?.data?.length > 0"
        >
          <table
            mat-table
            [dataSource]="DataSourceBranch"
            matSort
            #BranchSort="matSort"
            matTableExporter
            #exporterBranch="matTableExporter"
            class="mat-elevation-z8"
          >
            <!-- Sr No -->
            <ng-container matColumnDef="SrNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Sr No.</mat-header-cell
              >
              <mat-cell *matCellDef="let row; let i = index">{{
                i + 1
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
            </ng-container>

            <!-- Branch Name -->
            <ng-container matColumnDef="Branch_Name">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Branch Name</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{ row.Branch_Name }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Address -->
            <ng-container matColumnDef="BRANCH_ADDRESS">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Address</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.BRANCH_ADDRESS
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- District -->
            <ng-container matColumnDef="DISTRICT">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >District</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{ row.DISTRICT }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- State -->
            <ng-container matColumnDef="STATE">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >State</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{ row.STATE }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Deposit Accounts -->
            <ng-container matColumnDef="NO_OF_DEPOSIT_ACCOUNT">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >No. of Deposit Accounts</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.NO_OF_DEPOSIT_ACCOUNT
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalBranch("NO_OF_DEPOSIT_ACCOUNT") }}
              </mat-footer-cell>
            </ng-container>

            <!-- Loan Accounts -->
            <ng-container matColumnDef="NO_OF_LOAN_ACCOUNT">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >No. of Loan Accounts</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.NO_OF_LOAN_ACCOUNT
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalBranch("NO_OF_LOAN_ACCOUNT") }}
              </mat-footer-cell>
            </ng-container>

            <!-- Opening Date -->
            <ng-container matColumnDef="OPENING_DATE">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Opening Date</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.OPENING_DATE | date : "dd/MM/yyyy"
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>
            <!-- Closing_DATE -->
            <ng-container matColumnDef="Closing_DATE">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Closing Date</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.Closing_DATE | date : "dd/MM/yyyy"
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <!-- Outstanding Loan -->
            <ng-container matColumnDef="OUTSTANDING_LOAN">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                >Outstanding Loan</mat-header-cell
              >
              <mat-cell *matCellDef="let row">{{
                row.OUTSTANDING_LOAN | number
              }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>
                {{ getTotalBranch("OUTSTANDING_LOAN") | number }}
              </mat-footer-cell>
            </ng-container>

            <!-- Table Rows -->
            <mat-header-row
              *matHeaderRowDef="displayedColumnsBranch"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedColumnsBranch"
            ></mat-row>
            <mat-footer-row
              *matFooterRowDef="displayedColumnsBranch"
            ></mat-footer-row>
          </table>

          <!-- Footer Buttons + Paginator -->
          <div class="row m-0 align-items-center justify-content-between">
            <div class="col-md-4">
              <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportTableBranch(exporterBranch)"
              >
                <i class="fa fa-file-export mr-1"></i>
                Export
              </button>
            </div>

            <div class="col-md-8">
              <mat-paginator
                [pageSizeOptions]="[20, 50]"
                showFirstLastButtons
                #BranchPaginator
              ></mat-paginator>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
